"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseApiService_1 = require("../apiServices/baseApiService/BaseApiService");
var Url_1 = require("./Url");
var Types_1 = require("./Types");
var string_format_1 = tslib_1.__importDefault(require("string-format"));
var FunctionApis = /** @class */ (function () {
    function FunctionApis() {
    }
    FunctionApis.prototype.getFunctionsList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.FunctionTypeListUrl;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionApis.prototype.saveFunction = function (modelId, modelJson) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, response;
            return tslib_1.__generator(this, function (_a) {
                types = new Types_1.Types();
                response = types.saveType(JSON.stringify(modelJson), modelId);
                return [2 /*return*/, response];
            });
        });
    };
    FunctionApis.prototype.getFunction = function (modelId, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.TypeDefinitionsUrl + modelId + "/types/" + typeId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionApis.prototype.deleteFunction = function (modelId, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, response;
            return tslib_1.__generator(this, function (_a) {
                types = new Types_1.Types();
                response = types.deleteType(typeId, modelId);
                return [2 /*return*/, response];
            });
        });
    };
    FunctionApis.prototype.verifyFunctionExists = function (typeId, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.VerifyFunctionExists, typeId, name);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    return FunctionApis;
}());
exports.FunctionApis = FunctionApis;
//# sourceMappingURL=FunctionApis.js.map